import { motion } from 'framer-motion';
import React from 'react';
import { cardVariants } from '@/framer/cardVariants';
import { whileInView100once } from './whileInView';

const ScrollMotion100Once = ({ children }: { children: JSX.Element }) => {
  return (
    <motion.div {...whileInView100once}>
      <motion.div variants={cardVariants}>{children}</motion.div>
    </motion.div>
  );
};
export default ScrollMotion100Once;
